import { Currency } from '@/core/currency/interfaces';

const JOD: Currency = {
    name: 'Jordanian Dinar',
    demonym: 'Jordanian',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '400',
    symbol: 'JD',
    symbolNative: 'د.أ.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'JOD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default JOD;
